var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

exports = function () {
  function t(t, i) {
    if (void 0 === i && (i = {}), !(t instanceof window.AudioNode)) throw new Error("Oscilloscope source must be an AudioNode");
    t instanceof window.AnalyserNode ? (this || _global).analyser = t : ((this || _global).analyser = t.context.createAnalyser(), t.connect((this || _global).analyser)), i.fftSize && ((this || _global).analyser.fftSize = i.fftSize), (this || _global).timeDomain = new Uint8Array((this || _global).analyser.fftSize), (this || _global).drawRequest = 0;
  }

  var i = t.prototype;
  return i.animate = function (t, i, e, a, n) {
    var s = this || _global;
    if ((this || _global).drawRequest) throw new Error("Oscilloscope animation is already running");
    (this || _global).ctx = t, function o() {
      t.clearRect(0, 0, t.canvas.width, t.canvas.height), s.draw(t, i, e, a, n), s.drawRequest = window.requestAnimationFrame(o);
    }();
  }, i.stop = function () {
    (this || _global).drawRequest && (window.cancelAnimationFrame((this || _global).drawRequest), (this || _global).drawRequest = 0, (this || _global).ctx.clearRect(0, 0, (this || _global).ctx.canvas.width, (this || _global).ctx.canvas.height));
  }, i.draw = function (t, i, e, a, n) {
    void 0 === i && (i = 0), void 0 === e && (e = 0), void 0 === a && (a = t.canvas.width - i), void 0 === n && (n = t.canvas.height - e), (this || _global).analyser.getByteTimeDomainData((this || _global).timeDomain);
    var s = a / (this || _global).timeDomain.length;
    t.beginPath();

    for (var o = 0; o < (this || _global).timeDomain.length; o += 2) t.lineTo(i + o * s, e + n * ((this || _global).timeDomain[o] / 256));

    t.stroke();
  }, t;
}(); //# sourceMappingURL=oscilloscope.js.map


export default exports;